import { createContext, useContext } from 'react';
import { EditingViewState } from '../../components/settings/viewsManagement/EditingViewState';
import { UpdateViewRequest } from '../../Model/requests/UpdateViewRequest';
import { GearGridView } from '../../Model/GearGridView';

interface IViewsContext {
  views: GearGridView[] | undefined;
  selectedView: number | undefined;
  setSelectedView?: (view: number | undefined) => void;
  selectedViewData: GearGridView | undefined;
  mutateViewLoading: boolean;
  onUpdateView?: (data: UpdateViewRequest) => void;
  hasUnsavedChanges?: boolean;
  setHasUnsavedChanges?: (hasChanges: boolean) => void;
  editingViewState: EditingViewState;
  setEditingViewState?: (state: EditingViewState) => void;
}

export const initEditingViewState: EditingViewState = {
  fields: [],
  activeField: undefined,
  globalFilters: []
};

export const ViewsContext = createContext<IViewsContext>({
  views: undefined,
  selectedView: undefined,
  selectedViewData: undefined,
  mutateViewLoading: false,
  editingViewState: initEditingViewState
});

export const useViewsContext = () => useContext(ViewsContext);
